if (!customElements.get('share-modal-opener')) {
  class ShareModalOpener extends HTMLElement {
    constructor() {
      super();
      this.bindOnClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.button.addEventListener('click', this.bindOnClick);
    }

    onClick() {

      if (this.dataset.mobile == 'device' && window.innerWidth < 750) {
        this.openDeviceModal();
        return
      }

      this.openModal(this.button);
    }

    openModal(trigger) {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(trigger || this.button);
    }

    async openDeviceModal() {
      if (navigator.share) {
        try {
          await navigator.share({
            title: document.querySelector('meta[property="og:title"]')?.content || document.title,
            url: window.location.href
          });
        } catch (err) {
          console.error('Share cancelled or failed:', err);
        }
      } else {
        // Fallback for unsupported devices/browsers
        alert(window.accessibilityStrings.shareNotSupported);
      }
    }
  }

  customElements.define('share-modal-opener', ShareModalOpener)
}

if (!customElements.get('share-modal')) {
  class ShareModal extends ModalDialog {
    constructor() {
      super();
    }
  }

  customElements.define('share-modal', ShareModal)
}